import BaseView from "../../../vendor_core/core/src/views/BaseView";
import PointerEvents from "../../../vendor_core/core/src/const/PointerEvents";
import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import ReelGroup from "../../../vendor_core/core/src/views/ReelGroup";
import spinModel from "../../../vendor_core/core/src/model/SpinModel";
import { Sprite } from "pixi.js";

class CustomReelBacks extends BaseView {

    protected reelBgs:Sprite[];
    protected reelGroup:ReelGroup;
    constructor(reelGroup:ReelGroup)
    {
        super();
        this.reelGroup = reelGroup;
    }


    create()
    {
        this.reelBgs = [];

        let cfg = this.config;
        let numReels = this.config.numReels;

        let reelBg, currX = 0;
        for (let reelIdx = 0; reelIdx < numReels; reelIdx++)
        {
            reelBg = this.assets.getSprite("reelsBgColour");
            reelBg.interactive = true;
            reelBg.on(PointerEvents.DOWN, this.onReelDown, this);
            this.addChildAt(reelBg,0);

            let numSyms = this.config.numSymsPerReel[reelIdx];

            reelBg.height = numSyms * cfg.symHeight + (numSyms - 1) * cfg.symGap + cfg.marginTop + cfg.marginBottom;

            if (reelIdx == 0)
            {
                reelBg.width = cfg.symWidth + cfg.reelGap * .5 + cfg.marginLeft;
            }
            else if (reelIdx == (numReels - 1))
            {
                reelBg.width = cfg.symWidth + cfg.reelGap * .5 + cfg.marginRight;
            }
            else
            {
                reelBg.width = cfg.symWidth + cfg.reelGap;
            }

            reelBg.x = currX;
            currX += reelBg.width;

            if (reelIdx < (numReels-1))
            {
                let reelSeparator = this.assets.getSprite("reelsDividerColour");
                reelSeparator.anchor.set(.5,0);
                reelSeparator.width = 7;
                reelSeparator.height = reelBg.height;
                reelSeparator.x = currX;
                this.addChild(reelSeparator);
            }

            this.reelBgs.push(reelBg);
        }

        this.scale.set(this.reelGroup.scale.x);
        this.x = this.reelGroup.x;
        this.y = this.reelGroup.y;

        this.dispatcher.on(GameEvents.GAME_STATE_CHANGED, this.onStateChanged, this);
        this.dispatcher.on(GameEvents.ALL_REELS_STOPPED, this.onAllReelsStopped, this);
    }


    onAllReelsStopped()
    {
        //TODO SOME SORT OF STATE MACHINE
        // if (this.controller.getState() == C_GameState.FINISH_SPIN_2)
        // {
            this.reelBgs.forEach(reelBg => this.setReelBgState(reelBg, false));
        // }
    }


    onStateChanged()
    {
        //TODO SOME SORT OF STATE MACHINE
        // if (this.controller.getState() == C_GameState.IDLE_2)
        // {
            // let holdsPattern = this.model.getPlayerHoldsPattern();
            // for (let reelIdx=0; reelIdx < holdsPattern.length; reelIdx++)
            // {
            //     this.setReelBgState(this.reelBgs[reelIdx], holdsPattern[reelIdx]);
            // }
        // }
    }


    onReelDown(e:any)
    {
        let reelBg = e.target;
        this.setReelBgState(reelBg, !reelBg.isSelected);
        let idx = this.reelBgs.indexOf(reelBg);
        spinModel.getPlayerHoldsPattern()[idx] = reelBg.isSelected;
    }


    setReelBgState(reelBg:Sprite, selected:boolean)
    {
        //TODO make it selectable
        // reelBg.isSelected = selected;
        reelBg.texture = this.assets.getTexture(selected ? "reelsBgHeldColour" : "reelsBgColour");
    }


}

export default CustomReelBacks